import React from 'react';
import FaIcon from './FaIcon';
import styles from '../styles/StellineRewardChip.module.css';

const toPositiveIntegerOrNull = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return null;
  const rounded = Math.trunc(parsed);
  return rounded > 0 ? rounded : null;
};

const StellineRewardChip = ({
  amount,
  minAmount = null,
  maxAmount = null,
  isMax = false,
  compact = false,
  className = '',
}) => {
  const resolvedAmount = toPositiveIntegerOrNull(amount);
  const resolvedMinAmount = toPositiveIntegerOrNull(minAmount);
  const resolvedMaxAmount = toPositiveIntegerOrNull(maxAmount);
  const hasRange = (
    resolvedMinAmount != null &&
    resolvedMaxAmount != null &&
    resolvedMaxAmount > resolvedMinAmount
  );

  const amountLabel = hasRange
    ? `+${resolvedMinAmount}-${resolvedMaxAmount}`
    : (resolvedAmount != null ? `+${resolvedAmount}` : null);

  const hasRenderableAmount = amountLabel != null || (resolvedMaxAmount != null && isMax);
  if (!hasRenderableAmount) {
    return null;
  }

  const classes = [
    styles.chip,
    compact ? styles.compact : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <span
      className={classes}
      aria-label={hasRange ? `${amountLabel}` : (isMax ? `Fino a ${resolvedMaxAmount}` : `${amountLabel}`)}
      title={hasRange ? amountLabel : (isMax ? `Fino a +${resolvedMaxAmount}` : amountLabel)}
    >
      {isMax && !hasRange && <span className={styles.maxPrefix}>fino a</span>}
      <span className={styles.amount}>{hasRange ? amountLabel : (amountLabel || `+${resolvedMaxAmount}`)}</span>
      <span className={styles.icon} aria-hidden="true">
        <FaIcon className={`fa-solid fa-star ${styles.iconGlyph}`} />
      </span>
    </span>
  );
};

export default StellineRewardChip;
